import { ThingEventSnapshot } from '@eagle/core-data-types';

export enum SummarizationMode {
  First = 'first',
  Last = 'last',
  All = 'all',
}

export enum ProcessedEventType {
  Summarized = 'summarized',
  Individual = 'individual',
}

export interface SummarizationRule {
  minCount: number;
  match?: Record<string, any>;
  keyCombination?: string[];
}

export interface EventSummarizationFeatureDefinition {
  eventTypeIds: Record<string, SummarizationMode>;
  matchRules: SummarizationRule[];
}

export interface EventSummarizationTemplate {
  [feature: string]: EventSummarizationFeatureDefinition;
}

export interface SummarizedEventGroup {
  type: typeof ProcessedEventType.Summarized;
  representativeEvent: ThingEventSnapshot;
  eventCount: number;
  originalEvents: ThingEventSnapshot[];
  feature: string;
  eventTypeId: string;
  groupKey: string;
  summarizationMode: SummarizationMode;
}

export interface IndividualEvent {
  type: typeof ProcessedEventType.Individual;
  event: ThingEventSnapshot;
}

export type ProcessedEvent = SummarizedEventGroup | IndividualEvent;
